import {
  toZonedTime,
  fromZonedTime,
  getTimezoneOffset as getTimezoneOffsetFns,
  formatInTimeZone as formatInTimeZoneFns,
  ToDateOptionsWithTZ,
  FormatOptionsWithTZ,
} from 'date-fns-tz'
import { getDateFnsLocale } from './locales'

export const zonedTimeToUtc = (
  date: Date | string | number,
  timeZone: string,
  options?: ToDateOptionsWithTZ
) => {
  return fromZonedTime(date, timeZone, options)
}

export const convertTimezoneToLocal = (date: Date | number | string, timezone: string) => {
  return toZonedTime(date, timezone)
}

export const getTimezoneOffset = (timeZone: string, date?: Date | number) => {
  return getTimezoneOffsetFns(timeZone, date)
}

export const convertTimezone = (date: Date | number, timezone: string) => {
  return zonedTimeToUtc(date, timezone)
}

type FormatOptions = Omit<FormatOptionsWithTZ, 'locale'> & { locale?: string }

export const formatInTimeZone = (
  date: string | number | Date,
  timezone: string,
  format: string,
  options?: FormatOptions
) => {
  const dateFnsLocale = getDateFnsLocale(options?.locale)
  return formatInTimeZoneFns(date, timezone, format, { ...options, locale: dateFnsLocale })
}
